import WorkspaceSelector from '../Helper/WorkspaceSelector';

/**
 * Helper for Components to validate if the user has the role to 
 * render the children Item
 */
const RoleGuard = ({ children, specificRole = null }) => {
    const {currentWorkspace} = WorkspaceSelector()
    const user = localStorage.getItem("user");

    const checkRole = (role) =>{
        return (role && specificRole == null ? (role === "OWNER" ||role === "MANAGER" || role === "ADMIN") : (role === specificRole || role === "ADMIN"))
    }

    if (user) {
        const parsedUser = JSON.parse(user);
            if (checkRole(parsedUser.role) || (parsedUser.workspace[currentWorkspace()] && checkRole(parsedUser.workspace[currentWorkspace()].role))) {
                return <>{children}</>;
            }
    }
    return null;
};

export default RoleGuard;
